import Quill from 'quill';

import ColorPaletteModule from './module';
import './scss/color-palette.sass';

Quill.register({
    'modules/colorPalette': ColorPaletteModule
}, true);

export default { ColorPaletteModule };
